import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {ReplaySubject} from 'rxjs';
import {CommissionImportRow} from '../../../../shared/interface/commission-import-row';
import {takeUntil} from 'rxjs/operators';
import {UserPermissions} from '../../../../shared/interface/user-permissions';
import {AuthService} from '../../../../shared/services/auth.service';
import {
  COMMISSION_SETTLEMENT_STATUS_CLOSED, COMMISSION_SETTLEMENT_STATUS_NEW,
  COMMISSION_SETTLEMENT_STATUS_SETTLED,
  COMMISSION_SETTLEMENT_STATUS_TO_GENERATE, RATE_THRESHOLD_10, RATE_THRESHOLD_40
} from "../../../../shared/services/dict.service";
import {JobResultDialogComponent} from "../../../../shared/components/job-result-dialog/job-result-dialog.component";
import {HttpErrorResponse} from "@angular/common/http";

@Component({
  selector: 'app-commission-details-view',
  templateUrl: './commission-details-view.component.html',
  styleUrls: ['./commission-details-view.component.scss']
})
export class CommissionDetailsViewComponent implements OnInit, OnDestroy {
  @Input() commissionImportRow: ReplaySubject<CommissionImportRow>;
  @Output() modifyClicked = new EventEmitter<any>();

  readonly COMMISSION_SETTLEMENT_STATUS_CLOSED = COMMISSION_SETTLEMENT_STATUS_CLOSED;
  readonly COMMISSION_SETTLEMENT_STATUS_SETTLED = COMMISSION_SETTLEMENT_STATUS_SETTLED;
  readonly COMMISSION_SETTLEMENT_STATUS_TO_GENERATE = COMMISSION_SETTLEMENT_STATUS_TO_GENERATE;
  readonly COMMISSION_SETTLEMENT_STATUS_NEW = COMMISSION_SETTLEMENT_STATUS_NEW;
  readonly RATE_THRESHOLD_40 = RATE_THRESHOLD_40;
  readonly RATE_THRESHOLD_10 = RATE_THRESHOLD_10;

  commissionImportRowObject: CommissionImportRow;
  userPermissions: ReplaySubject<UserPermissions>;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private auth: AuthService,
  ) {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnInit(): void {
    this.commissionImportRow
      .pipe(takeUntil(this.destroyed$))
      .subscribe((commissionImportRow: CommissionImportRow) => {
        this.commissionImportRowObject = commissionImportRow;
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  modify(): void {
    this.modifyClicked.emit();
  }

  calculateRateThreshold(row: CommissionImportRow, rate: number): number {
    if (row.manuallySet.includes(RATE_THRESHOLD_40)){
      return rate / 0.4;
    } else {
      return rate / 0.1;
    }

  }

}
